import { SET_NAVIGATOR_ONLINE } from 'reducers/actions-types';

export default function modalReducer(state = {
    isOnline: true,
}, { type, isOnline }) {
    switch (type) {
        case SET_NAVIGATOR_ONLINE:
            return Object.assign({}, state, {
                isOnline,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/navigator/index.js